import { ReactNode, useState, useRef } from "react";
import ReactDOM from "react-dom";
import "../../../../assets/css/tooltip-tw.min.css";

interface ITooltip {
  text: string;
  children: ReactNode;
  style?: React.CSSProperties;
  align?: "left" | "center" | "right";
  placement?: "top" | "bottom";
  offsetY?: number;
  /**
   * Override del `text-transform` de la burbuja. El CSS global la fuerza a
   * `capitalize` (cada palabra con mayúscula); pasar "none" respeta el texto
   * tal cual viene (solo la primera palabra con mayúscula, nombres propios y
   * siglas intactos). Sin este prop, se mantiene el comportamiento de siempre.
   */
  textTransform?: React.CSSProperties["textTransform"];
}

const alignTranslateX: Record<string, string> = {
  left: "-85%",
  center: "-50%",
  right: "-15%",
};

const Tooltip = ({ text, children, style, align = "left", placement = "top", offsetY = 0, textTransform }: ITooltip) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const containerRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setPos({
        top: (placement === "bottom" ? rect.bottom : rect.top) + offsetY,
        left: rect.left + rect.width / 2,
      });
    }
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <div
      ref={containerRef}
      className="tooltip-container"
      style={style}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {showTooltip &&
        ReactDOM.createPortal(
          <div
            className="tooltip-black"
            style={{
              position: "fixed",
              top: pos.top,
              left: pos.left,
              bottom: "unset",
              transform: `translateX(${alignTranslateX[align]}) translateY(${placement === "bottom" ? "6px" : "calc(-100% - 6px)"})`,
              textTransform,
            }}
          >
            <div className="arrow-black" />
            {text}
          </div>,
          document.body
        )}
    </div>
  );
};

export default Tooltip;
